import {AppLogo, AsyncImage} from "@components";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  SxProps,
  TextField,
  Theme,
  Typography,
} from "@mui/material";
import {useThemeContext} from "@theme";
import {translate} from "@util";

const MobileLogin = ({
  tenantImg,
  rememberMe,
  loading,
  tenantName,
  setRememberMe,
  onSubmit,
}: {
  tenantImg: string | undefined;
  tenantName: string | undefined;
  rememberMe: boolean;
  loading: boolean;
  setRememberMe: (v: boolean) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}) => {
  const {theme} = useThemeContext();

  const bgColor = theme.palette.background.default;
  const WebkitTextFillColor = `${theme.palette.text.primary} !important`;
  const WebkitBoxShadow = `0 0 0 100px ${bgColor} inset`;
  const textfieldSx: SxProps<Theme> = {
    "& input:-webkit-autofill": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:active": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
  };

  return (
    <Stack
      bgcolor={bgColor}
      justifyContent={"space-between"}
      alignItems={"center"}
      flex={"1 1 0"}
      direction="column">
      <Box />
      <Stack>
        <Stack alignItems={"center"}>
          <AppLogo logoSize={120} hideText containerSx={{mb: 2}} />
          <Typography variant="h5" color="primary">
            {translate("pages.login.text")}
          </Typography>
        </Stack>

        <Box
          component="form"
          onSubmit={onSubmit}
          noValidate
          sx={{p: 2, mx: 3, mt: 2}}>
          <TextField
            sx={textfieldSx}
            variant="standard"
            required
            fullWidth
            id="username"
            label={translate("pages.login.username")}
            name="username"
          />
          <TextField
            sx={textfieldSx}
            variant="standard"
            margin="normal"
            required
            fullWidth
            name="password"
            label={translate("pages.login.password")}
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(evt, checked) => setRememberMe(checked)}
              />
            }
            label={
              <Typography variant="body1" color="textPrimary">
                {translate("pages.login.rememberMe")}
              </Typography>
            }
          />
          <Button
            loading={loading}
            type="submit"
            fullWidth
            variant="contained"
            sx={{mt: 3}}>
            {translate("pages.login.login")}
          </Button>
        </Box>
      </Stack>

      <AsyncImage
        id={tenantImg}
        sx={{mb: 4}}
        height={80}
        size="contain"
        fallbackNode={
          <Typography
            variant={"h5"}
            align="center"
            color={theme.palette.common.white}>
            {tenantName}
          </Typography>
        }
      />
    </Stack>
  );
};

export {MobileLogin};
